import script from "./Pane5.vue?vue&type=script&setup=true&lang=js"
export * from "./Pane5.vue?vue&type=script&setup=true&lang=js"

import "./Pane5.vue?vue&type=style&index=0&id=7b9245de&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b9245de"]])

export default __exports__